import moment from "moment";
import { Div, RefObject, Ref, RefString, Image, Text } from "@tblabs/truffle";
import { PictureConverter } from "../Models/PictureConverter";
import { PictureForWebClient } from "../Models/PictureForWebClient";
import { ByteUtils } from "../Services/ByteUtils";
import { TimeUtils } from "../Services/TimeUtils";


export class DevicePicture extends Div
{
    constructor(thumbnail: RefObject<PictureForWebClient>, pictureInfo: Ref<string>)
    {
        super("image");

        const picTime = new RefString(this.GetPictureTime(thumbnail));
        const picSize = new RefString(this.GetPictureSize(thumbnail));

        const picturePreview = new Image();

        if (thumbnail.object?.Image)
            picturePreview.FromBlob(PictureConverter.ConvertBufferToBlob(thumbnail.object.Image)).Class("image");

        thumbnail.OnChange((blobPicture: PictureForWebClient) =>
        {
            if (!blobPicture)
            {
                picTime.value = "last tried at " + moment().format("HH:mm:ss");
                picSize.value = "";
                return;
            }

            picTime.value = this.GetPictureTime(thumbnail);
            picSize.value = this.GetPictureSize(thumbnail);

            picturePreview.FromBlob(PictureConverter.ConvertBufferToBlob(blobPicture.Image));
        });

        this.Append(
            picturePreview,
            new Text(pictureInfo).Class("picture-info"),
            new Text(picTime).Class("time"),
            new Text(picSize).Class("image-size")
        );
    }

    public GetPictureTime(thumbnail: RefObject<PictureForWebClient>): string
    {
        if (!thumbnail.object)
        {
            return "no pic";
        }

        let lastPictureTime = moment(thumbnail.object.PictureTime);

        const secDiff = moment().diff(lastPictureTime, "seconds");
        if (secDiff > 0)
            return TimeUtils.SecondsToHHMMSS(secDiff) + " ago";
        else
            return "at " + lastPictureTime.format("DD.MM.YYYY HH:mm:ss");
    }

    public GetPictureSize(thumbnail: RefObject<PictureForWebClient>): string
    {
        const size = thumbnail.object ? ByteUtils.HumanReadable(thumbnail.object.Size) : "";
        return size;
    }
}
